import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { post } from '../../utils/api';
import './Translate.css';
//
// Кнопка перевода под полем ввода в форме
//
export interface TranslateProps {
    current: string; // текущая строка в поле ввода
    text: string; // строка для перевода
    from: 'en'|'ru'; // с какого языка переводим
    limit: number; // ограничение на длину получаемого перевода
    setText: (s: string) => void; // функция установки перевода в поле ввода
    setIsTranslating: (b: boolean) => void; // функция установки флага того что перевод в процессе
};

const Translate: FC<TranslateProps> = ({ current, text, from, limit, setText, setIsTranslating }) => {
	const { t } = useTranslation();

    const doTranslate = async () => {
        setText(t('common.translating'));
        setIsTranslating(true);
        const result = await post('/translate', { text, from });
        if(result.data) {
            setText((result.data.translation as string).substring(0, limit));
        } else {
            setText(text.substring(0, limit));
        }
        setIsTranslating(false);
    };
    
    return <span className='Translate'>
        <span>{current ? `${current.length} / ${limit}`: `Max: ${limit}`}</span>
        {text && <span onClick={() => doTranslate()}>{t(`common.translate_from_${from}`)}</span>}
    </span>;
};

export default Translate;
